<template>
  <div
    class="app-modal"
    :class="[showModal ? 'show' : 'hide']"
    @click="closeModal"
  >
    <div class="app-modal-content" @click.stop :style="styleReturned">
      <slot></slot>
      <div class="form__action-wrap">
        <span @click="cancelModal" v-if="showCancelButton" class="form__back">{{
          cancelButtonText
        }}</span>
        <button
          class="cta_btn dashboard__btn d-inline"
          v-if="showOkBtn"
          @click="okButtonClick" 
        >
        <svgicon
              icon="spinner"
              class="button__loader"
              v-if="loader"
            ></svgicon>
          {{ okBtnText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppModal",
  props: {
    show: Boolean,
    showOkButton: Boolean,
    okButtonText: String,
    showCancelBtn: Boolean,
    cancelBtnText: String,
    styleGotten: Object,
    loader: Boolean
  },

  computed: {
    showModal() {
      return this.show;
    },
    showOkBtn() {
      return this.showOkButton;
    },
    okBtnText() {
      return this.okButtonText || "Okay";
    },
    showCancelButton() {
      return this.showCancelBtn;
    },
    cancelButtonText() {
      return this.cancelBtnText || "Cancel";
    },
    styleReturned() {
      return this.styleGotten;
    }
  },
  methods: {
    closeModal(event) {
      this.$emit("onclosed", true);
    },
    cancelModal(event) {
      this.$emit("oncancel", true);
    },
    okButtonClick(event) {
      this.$emit("onapprove", true);
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/resuables/modal.vue